import * as React from "react";

import { usePdpAnalytics, useReactPdpInitialState } from "../providers";

export const PageWideAnalytics: React.FunctionComponent = () => {
  const { initialState } = useReactPdpInitialState();

  const { analytics, implementations } = usePdpAnalytics();

  const [hasInitialized, setHasInitialized] = React.useState(false);

  const hasInitialized_analytics = React.useMemo(() => {
    let areThereAnyUnintialized = implementations.some((implementation) => {
      if (!implementation.hasInitialized) {
        return true;
      }
      return false;
    });

    const hasInitialized_analytics = !areThereAnyUnintialized;
    return hasInitialized_analytics;
  }, [implementations, analytics]);

  React.useEffect(() => {
    if (!hasInitialized && hasInitialized_analytics) {
      const { productId } = initialState;
      if (productId) {
        analytics.viewActionOnProduct({ productId });
      }
      setHasInitialized(true);
    }
  }, [hasInitialized, initialState, analytics, hasInitialized_analytics]);

  const handlePdpAddToBag = React.useCallback(() => {
    (window.require as any)(["jquery"], function ($: any) {
      const $productTable = $("#super-product-table");
      const $qtyInputs = $productTable.find("input.qty");

      let addToBagItems: {
        productId: string;
        quantity: number;
      }[] = [];
      $qtyInputs.each((index: number, qtyInput: any) => {
        const $qtyInput = $(qtyInput);
        const qtyInputValue = qtyInput.value;

        const quantity = Number.parseInt(qtyInputValue);
        if (!quantity || quantity < 1 || !isFinite(quantity)) {
          return;
        }

        const thisProductId = $qtyInput.data("product-id");

        const thisAddToBagItem = {
          productId: thisProductId,
          quantity,
        };

        addToBagItems = [...addToBagItems, ...[thisAddToBagItem]];
      });

      addToBagItems.forEach((item) => {
        analytics.addToCartAction(item);
      });
    });
  }, [analytics]);
  React.useEffect(() => {
    window.addEventListener("pdp-add-to-bag", handlePdpAddToBag);
    return () => {
      window.removeEventListener("pdp-add-to-bag", handlePdpAddToBag);
    };
  }, [handlePdpAddToBag]);

  return null;
};
